import styled from "styled-components";

export const FormHeading = styled.h2`
  text-align: center;
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  line-height: 36px;
  margin: 1rem 0 0 0;
`;

export const FormSubHeading = styled.p`
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.neutral[600]};
  font-family: ${({ theme }) => theme.fonts.secondary};
  margin: 10px;
`;

export const SendCTAWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 24px auto 0;
  width: 320px;
`;

export const MobileInputContainer = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  margin-top: 1rem;
`;
